<script setup lang="ts">
const criteriaStore = useSearchCriteriaStore();
</script>

<template>
  <span class="whitespace-nowrap text-xs font-normal text-text-inverse md:hidden">
    {{ $t(`components.search.cabinClassSelectorShort.${criteriaStore.committedCriteriaKey.cabinClass}`) }}
  </span>
  <span class="hidden min-w-0 truncate text-sm font-normal text-text-inverse md:inline">
    {{ $t(`components.search.cabinClassSelector.${criteriaStore.committedCriteriaKey.cabinClass}`) }}
  </span>
</template>
